import { render, staticRenderFns } from "./WidgetGrey.vue?vue&type=template&id=7845dbd5"
import script from "./WidgetGrey.vue?vue&type=script&lang=js"
export * from "./WidgetGrey.vue?vue&type=script&lang=js"
import style0 from "./WidgetGrey.vue?vue&type=style&index=0&id=7845dbd5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports